module.exports = __webpack_public_path__ + "files/CleanHandPROX.a5f16ae27f1fce599c3060cb133775cc.pdf";